// Questions for the TCM Constitution Questionnaire
export const questions = [
  'Were you energetic?',
  'Did you get tired easily?',
  'Did you suffer from shortness of breath?',
  'Did you get palpitations?',
  'Did you get dizziness easily or become giddy when standing up?',
  'Did you prefer quietness and do not like to talk?',
  'Did you feel weak when talking?',
  'Did you forget things easily?',
  'Did you feel gloomy and depressed?',
  'Did you get anxious and worried easily?',
  'Did you feel sensitive, vulnerable or emotionally upset?',
  'Were you easily scared or frightened?',
  'Did you experience distention in the underarm or breast?',
  'Did you feel chest or stomach stuffiness?',
  'Did you sigh for no reason?',
  'Did your body feel heavy or lethargic?',
  'Did the palms of your hands or soles of your feet feel hot?',
  'Did your hands or feet feel cold or clammy?',
  'Did you feel cold easily in your abdomen, back, lower back or knees?',
  'Were you sensitive to cold and tend to wear more clothes than others?',
  'Did your body and face feel hot?',
  'Did you feel more vulnerable to the cold than others (winter coldness, air conditioners, fans, etc.)?',
  'Did you catch colds more easily than others?',
  'Did you sneeze even when you did not have a cold?',
  'Did you have runny or stuffy nose even when you did not have a cold?',
  'Did you cough due to seasonal change, temperature change, or unpleasant odor?',
  'Did you sweat easily when you had a slightly increased physical activity?',
  'Did you have an excessively oily forehead and/or T-zone?',
  'Did your skin or lips feel dry?',
  'Did you have allergies? (E.g. medicine, food, odors, pollen, pet dander, or during seasonal or weather change etc.)',
  'Did your skin get hives/urticaria easily?',
  'Did your skin have purpura (purple spots, ecchymosis) due to allergies?',
  'Did black or purple bruises appear on your skin for no reason?',
  'Did your skin turn red and show traces when you scratched it?',
  'Were your lips redder than others?',
  'Did you have visible capillary/thread veins on your cheeks?',
  'Did you feel pain somewhere in your body?',
  'Did you get hot flashes?',
  'Did your nose or your face feel greasy, oily, or shiny?',
  'Did you have a dark face or get brown spots easily?',
  'Did you get acne or sores easily?',
  'Did you have upper eyelid swelling?',
  'Did you get dark circles under the eyes easily?',
  'Did your eyes feel dry and use eye drops?',
  'Did your lips become darker or purple than usual?',
  'Did you often feel parched and need to drink water?',
  'Did your throat feel strange (i.e. like something was stuck or there was a lump in your throat)?',
  'Did you have bitterness or a strange taste in your mouth?',
  'Did your mouth feel sticky?',
  'Did your tongue have a thick coating?',
  'Did you have lots of phlegm, especially in your throat?',
  'Did you feel uncomfortable when you drank or ate something cold, or do you avoid drinking or eating something cold?',
  'Could you adapt yourself to external natural or social environment change?',
  'Did you suffer from insomnia?',
  'Did you easily contract diarrhea when you were exposed to cold or eat (or drink) something cold?',
  'Did you pass sticky stools and/or feel that your bowel movement is incomplete?',
  'Did you get constipated easily or have dry stools?',
  'Was your stomach/belly flabby?',
  'Did your urethral canal feel hot when you urinated, or did your urine have a dark color?',
  'Was your vaginal discharge yellowish? (Female only)',
  'Was your scrotum always wet? (Male only)',
]
// Constitution types with their corresponding questions and scoring rules
export const constitutions = {
  Balanced: {
    items: [1, 2, 7, 8, 9, 22, 53, 54],
    reversed: [2, 7, 8, 9, 22, 54],
    description: 'Peaceful and harmonious constitution',
  },
  'Yang-deficient': {
    items: [18, 19, 20, 22, 23, 52, 55],
    reversed: [],
    description: 'Cold constitution with yang qi deficiency',
  },
  'Yin-deficient': {
    items: [17, 21, 29, 35, 38, 44, 46, 57],
    reversed: [],
    description: 'Hot constitution with yin fluid deficiency',
  },
  'Qi-deficient': {
    items: [2, 3, 4, 5, 6, 7, 23, 27],
    reversed: [],
    description: 'Weak constitution with qi energy deficiency',
  },
  'Phlegm-dampness': {
    items: [14, 16, 28, 42, 49, 50, 51, 58],
    reversed: [],
    description: 'Heavy constitution with phlegm and dampness accumulation',
  },
  'Damp-heat': {
    items: [39, 41, 48, 56, 59, 60],
    reversed: [],
    description: 'Constitution with dampness and heat accumulation',
  },
  'Stagnant Blood': {
    items: [8, 33, 36, 37, 40, 43, 45],
    reversed: [],
    description: 'Constitution with blood circulation problems',
  },
  'Stagnant Qi': {
    items: [9, 10, 11, 12, 13, 15, 47],
    reversed: [],
    description: 'Constitution with qi circulation problems',
  },
  'Inherited Special': {
    items: [24, 25, 26, 30, 31, 32, 34],
    reversed: [],
    description: 'Special inherited constitution with allergic tendencies',
  },
}
// Response options for each question
export const responseOptions = [
  { value: 1, label: 'None (1)', description: 'Never happened' },
  { value: 2, label: 'Rarely (2)', description: 'Occasionally happened' },
  {
    value: 3,
    label: 'Sometimes (3)',
    description: 'Sometimes it happened, but no regular pattern',
  },
  { value: 4, label: 'Often (4)', description: 'It happened most of the time' },
  { value: 5, label: 'Always (5)', description: 'It happened all the time' },
]
// Function to determine constitution status based on score
export const determineConstitutionStatus = (
  score: number,
  constitution: string,
): string => {
  if (constitution === 'Balanced') {
    if (score >= 60) return 'Yes'
    if (score >= 40) return 'Basically Yes'
    return 'No'
  } else {
    if (score >= 40) return 'Yes'
    if (score >= 30) return 'Tend to'
    return 'No'
  }
}
